import { isJsonString } from 'helpers/textEditor';
import { decodeHtmlEntities } from 'helpers/htmlEntities';

const stripWrappingDoubleQuotes = (value: string) => {
  const trimmedValue = value.trim();

  if (
    trimmedValue.length >= 2 &&
    trimmedValue.startsWith('"') &&
    trimmedValue.endsWith('"')
  ) {
    return trimmedValue.slice(1, -1).trim();
  }

  return trimmedValue;
};

const PARAGRAPH_BREAK_TOKEN = '__PROFILE_BIO_PARAGRAPH_BREAK__';
const LINE_BREAK_TOKEN = '__PROFILE_BIO_LINE_BREAK__';
const ESCAPED_NEWLINE_SEQUENCE = /(?:\\r\\n|\\n|\\r)/g;

const normalizePlainText = (value: string) =>
  stripWrappingDoubleQuotes(
    decodeHtmlEntities(value)
      .replace(ESCAPED_NEWLINE_SEQUENCE, ' ')
      .replace(new RegExp(PARAGRAPH_BREAK_TOKEN, 'g'), '\n\n')
      .replace(new RegExp(LINE_BREAK_TOKEN, 'g'), '\n')
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/[ \t]*\n[ \t]*/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim()
  );

const unwrapStoredRichTextValue = (value: string) => {
  const trimmedValue = value.trim();

  if (!isJsonString(trimmedValue)) {
    return trimmedValue;
  }

  const parsedValue = JSON.parse(trimmedValue);

  return typeof parsedValue === 'string' ? parsedValue : trimmedValue;
};

export const convertHtmlBioToPlainText = (value?: string | null) => {
  if (!value) {
    return '';
  }

  const normalizedValue = unwrapStoredRichTextValue(value);

  if (!/<[a-z][\s\S]*>/i.test(normalizedValue)) {
    return normalizePlainText(normalizedValue);
  }

  const htmlWithLineBreaks = normalizedValue
    .replace(/<\s*br\s*\/?>/gi, LINE_BREAK_TOKEN)
    .replace(/<\/p>\s*<p[^>]*>/gi, PARAGRAPH_BREAK_TOKEN)
    .replace(/<\/div>\s*<div[^>]*>/gi, PARAGRAPH_BREAK_TOKEN)
    .replace(/<\/li>\s*<li[^>]*>/gi, LINE_BREAK_TOKEN)
    .replace(/<li[^>]*>/gi, '- ')
    .replace(/<\/?(p|div|ul|ol)[^>]*>/gi, '')
    .replace(/[\r\n\t]+/g, ' ');

  if (typeof document === 'undefined') {
    return normalizePlainText(
      htmlWithLineBreaks.replace(/<[^>]+>/g, '').trim()
    );
  }

  const temp = document.createElement('div');
  temp.innerHTML = htmlWithLineBreaks;

  return normalizePlainText((temp.textContent || temp.innerText || '').trim());
};
